const HEADER_HEIGHT_LG = '6.25rem';
const HEADER_HEIGHT_MD = '3.625rem';
const HEADER_HEIGHT_SM = '3rem';
const ACCORDION_SUBMENU_HEIGHT_LG = '3.75rem';

const HEADER_LOGO_MOBILE_WIDTH = '18.75rem';
const HEADER_LOGO_DESKTOP_WIDTH = '9.5rem';

export {
  HEADER_HEIGHT_LG,
  HEADER_HEIGHT_MD,
  HEADER_HEIGHT_SM,
  ACCORDION_SUBMENU_HEIGHT_LG,
  HEADER_LOGO_MOBILE_WIDTH,
  HEADER_LOGO_DESKTOP_WIDTH,
};
